export const image = 'https://source.unsplash.com/random'

export const header = require('../../static/assets/images/red-curtain.jpg')

export default undefined



// WEBPACK FOOTER //
// ./src/constants/mock.js